module.exports = __webpack_public_path__ + "static/media/Temperance.d6835c2b.png";